import './houses.scss'
import { houses } from '../../../Dummy Data/Houses'
import { Link } from 'react-router-dom'
// import { useContext } from 'react'
// import { houseContext } from '../../../HouseContext'


const Houses = () => {
    // const { filteredHouses } = useContext(houseContext)
  return (
    <div className='houses'>
        {houses.map(house => (
            <Link to={`/explore/${house.title}`} className='featured-card' key={house.id}>
                <div className="img">
                    <img src={house.image} alt="house1" />
                </div>
                <div className="featured-description">
                    <h2>{house.title}</h2>
                    <p>{house.description}</p>
                    <p><b>Price:</b> ${house.price}</p>
                    <p><b>Location:</b> {house.location}</p>
                    <p><b>Category:</b> {house.category}</p>
                </div>
                <button className="view-more">View More</button>
            </Link>
        ))}
    </div>
  )
}

export default Houses
